import React, { useEffect, useState } from 'react';
import { Button, Tag } from '@ontruck/orc';

import serialize from 'utils/serialize';
import config from 'config';
import * as http from 'utils/http';

import DriverJourneys from 'modules/driver-journeys';
import Loader from 'modules/Common/Loader';
import { injectIntl } from 'react-intl';

const DriverJourneysButton = ({ driverId, startTimeFrom, intl }) => {
  const t = intl.messages.modules.statusInfo;

  const [numberOfJourneys, setNumberOfJourneys] = useState(null);
  const moreThanOneJourney = numberOfJourneys > 1;
  const buttonText = `${t.driver_day} (${moreThanOneJourney ? '+' : ''}${numberOfJourneys - 1})`;

  useEffect(() => {
    (async function getNumberOfJourneys() {
      try {
        const queryString = serialize({
          page_size: 0,
          driver: driverId,
          transit_status: 'in_transit',
        });

        const response = await http.get(
          `${config.API_URL}mercury/count/journeys_by_driver/?${queryString}`
        );
        const [journeysNumber] = Object.values(response || {});

        setNumberOfJourneys(journeysNumber);
      } catch (e) {
        console.error(e);
      }
    })();
  }, [driverId, startTimeFrom]);

  if (!numberOfJourneys) return <Loader text={t.loading} />;
  return (
    <>
      {!moreThanOneJourney && (
        <Tag skin="modernLightGrey" weight="bold">
          {t.no_more_journeys}
        </Tag>
      )}
      {moreThanOneJourney && (
        <DriverJourneys customTrigger="click" driverId={driverId} timeFrom={startTimeFrom}>
          <Button
            iconPosition="left"
            icon="select-contact"
            skin="cancel"
            noWrap
            text={buttonText}
          />
        </DriverJourneys>
      )}
    </>
  );
};

export default injectIntl(DriverJourneysButton);
